import React from "react"
import {NavLink} from "react-router-dom";
import euLogo from "../../../../common/src/assets/img/brand/co-funded-cosme-horiz_en-no-bg.png"



class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

 render() {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
              </div>
              <div className="level-item">
                <span>
                  <figure className="logo">
                    <img src={euLogo}
                         alt="Co-funded by the COSME programme of the European Union"/>
                  </figure>
                </span>
              </div>
            </div>
            <div className="level-right">
                 <div className="level-item">
                       <NavLink to="/terms">
                                 <span className="submenu-item-label">Terms of use </span>
                       </NavLink>
                 </div>
                 <div className="level-item"> <p> | </p></div>
                   <div className="level-item">
                         <NavLink to="/privacy">
                                    <span className="submenu-item-label">Privacy policy </span>
                         </NavLink>
                    </div>
                 </div>
          </div>
        </div>
      </footer>
    )
  }
}


export default Footer
